import * as React from "react";

import { useSelector, useDispatch } from "../../../../store";
import { toggleModuleBreak } from "../../../../store/slices/learner";
import { Box, Typography } from "@mui/material";

import RedirectButton from "./../../../ui-components/Buttons/RedirectButton";
import FinishQuizDialog from "./FinishLaterDialog";
import { moduleLables } from "../../../../constants";

export default function MobileModuleBreak() {
	const learner = useSelector((state) => state.learner || {});
	const dispatch = useDispatch();

	const handleContinue = async () => {
		await dispatch(toggleModuleBreak());
	};
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
					textAlign: "center",
				}}
			>
				<Typography
					variant="h3_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						color: "#06b6ad",
					}}
				>
					Well Done
				</Typography>
				<Typography variant="h5" sx={{ mt: 4 }}>
					You have finished the{" "}
					<b>{moduleLables[learner?.modules?.previous] || ""}</b>{" "}
					Questions.
				</Typography>
				<Typography variant="h5" sx={{ mt: 5 }}>
					Continue to{" "}
					<b>{moduleLables[learner?.modules?.new] || ""}</b>{" "}
					Questions.
				</Typography>

				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "space-between",
						mt: 5,
					}}
				>
					<FinishQuizDialog 
						buttonStyle={{
							borderRadius: "20px",
							p: "5px 25px",
							fontSize: "1.1rem",
							backgroundColor: "#f24242",
						}}
						title="FINISH LATER"
					/>
					<RedirectButton
						// url="/question"
						handleClick={handleContinue}
						removeSpacer={true}
						title="CONTINUE"
					/>
				</Box>
			</Box>
		</React.Fragment>
	);
}